module.exports = __webpack_public_path__ + "img/life-culture.8faf21de.jpg";